<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.login_pwd_tip')" class="nav-bar" left-arrow @click-left="back()" />

    <!-- 卡片式容器 -->
    <div class="card-container">
      <div class="card-title">{{ $t('setting.login_pwd_tip') }}</div>
      
      <div class="input-item">
        <div class="label">{{ $t('setting.old_pwd') }}</div>
        <van-field
          v-model="old_password"
          :type="showOld ? 'text' : 'password'"
          :placeholder="$t('setting.old_pwd_tip')"
          :right-icon="showOld ? 'eye-o' : 'closed-eye'"
          @click-right-icon="showOld = !showOld"
          class="custom-field"
        />
      </div>

      <div class="input-item">
        <div class="label">{{ $t('setting.new_pwd') }}</div>
        <van-field
          v-model="o_new_password"
          :type="showNew ? 'text' : 'password'"
          :placeholder="$t('setting.new_pwd_tip')"
          :right-icon="showNew ? 'eye-o' : 'closed-eye'"
          @click-right-icon="showNew = !showNew"
          class="custom-field"
        />
      </div>

      <div class="input-item">
        <div class="label">{{ $t('setting.new_pwd1') }}</div>
        <van-field
          v-model="t_new_password"
          :type="showConfirm ? 'text' : 'password'"
          :placeholder="$t('setting.new_again_tip')"
          :right-icon="showConfirm ? 'eye-o' : 'closed-eye'"
          @click-right-icon="showConfirm = !showConfirm"
          class="custom-field"
        />
      </div>

      <van-button round block type="info" :loading="loading" class="submit-btn" @click="save">
        {{ $t("setting.save") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      old_password: "",
      o_new_password: "",
      t_new_password: "",
      showOld: false,
      showNew: false,
      showConfirm: false,
      loading: false,
    };
  },
  methods: {
    back() { history.back(); },
    save() {
      if (!this.old_password || !this.o_new_password || !this.t_new_password) {
        this.$toast.fail(this.$t("setting.prefect"));
        return;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast.fail(this.$t("setting.pwd_error"));
        return;
      }
      this.loading = true;
      this.$http({
        method: 'post',
        data: { old_password: this.old_password, new_password: this.o_new_password },
        url: 'user_set_loginpw'
      }).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.$toast.success(res.msg);
          setTimeout(() => { localStorage.clear(); this.$router.push("/Login"); }, 1000);
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => { this.loading = false; });
    }
  }
};
</script>

<style lang='less' scoped>
.container {
  background-color: #f2f2f5; /* 浅灰色背景，衬托卡片 */
  min-height: 100vh;
  padding-top: 20px;
}

/* 卡片样式 */
.card-container {
  background: #fff;
  margin: 0 15px;
  padding: 25px;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06); /* 轻微阴影，悬浮感 */
}

.card-title {
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
}

.input-item {
  margin-bottom: 25px;
}

.label {
  font-size: 28px;
  color: #666;
  margin-bottom: 15px;
}

/* 覆盖Vant field样式，使其更简洁 */
.custom-field {
  background-color: #f8f8f8;
  border-radius: 12px;
  padding: 15px 20px;
  font-size: 28px;
}

.submit-btn {
  margin-top: 40px;
  height: 90px;
  font-size: 32px;
  background: linear-gradient(to right, #1989fa, #0570db);
  border: none;
}
</style>